import React from "react";

const SymptomCheckboxGroup = ({
  sectionKey = "symptoms",       // e.g., "symptoms" or "medications"
  title = "Do you presently have any of the following symptoms?",
  symptomsData = {},             // e.g., { Fever: null, Cough: true }
  onChange,                      // (sectionKey, symptom, value) => void
  isDisabledYes = false,
  isDisabledNo = false,
}) => {
  return (
    <div>
      {/* Header */}
      <div className="mb-4 flex justify-between items-center">
        <label className="block text-base font-medium text-black">{title}</label>
        <div className="flex gap-4">
          <span className="text-base font-medium text-black">Yes</span>
          <span className="text-base font-medium text-black">No</span>
        </div>
      </div>

      {/* Symptoms list */}
      {Object.keys(symptomsData).map((symptom) => (
        <div
          key={symptom}
          className="flex items-center justify-between mb-4"
        >
          <label className="text-base font-medium text-black">
            {symptom} {" "}
            <span className="text-red-500">*</span>
          </label>
          <div className="flex items-center gap-4">
            {/* Yes Radio */}
            <input
              type="radio"
              name={`${sectionKey}-${symptom}`}
              value="yes"
              checked={symptomsData[symptom] === true}
              onChange={() => onChange(sectionKey, symptom, true)}
              disabled={isDisabledYes}
              className="form-radio h-5 w-5 text-blue-600 border-gray-700 rounded"
            />
            {/* No Radio */}
            <input
              type="radio"
              name={`${sectionKey}-${symptom}`}
              value="no"
              checked={symptomsData[symptom] === false}
              onChange={() => onChange(sectionKey, symptom, false)}
              disabled={isDisabledNo}
              className="form-radio h-5 w-5 text-blue-700 border-gray-700 rounded"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default SymptomCheckboxGroup;
